import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find";
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/reduce";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import { FILL_OUT_SECTIONS } from "@Client/@Utils/enums";
export const SESSION_TOKEN = "SESSION_TOKEN";
export const GET_FILL_OUT_SECTIONS_SCHEMA_KEYS = "GET_FILL_OUT_SECTIONS_SCHEMA_KEYS";
export const FILL_OUT_HAS_COAPPLICANTS = "FILL_OUT_HAS_COAPPLICANTS";
export const FILL_OUT_APPLICATION_STATUS = "FILL_OUT_APPLICATION_STATUS";
export const CO_APPLICANTS_CONSOLIDATED_REQUEST_FILL_OUT = "CO_APPLICANTS_CONSOLIDATED_REQUEST_FILL_OUT";
export const GUEST_FILL_OUT_CLIENT_DETAILS = "GUEST_FILL_OUT_CLIENT_DETAILS";
const getters = {
  [SESSION_TOKEN]: state => {
    return state.guestFillOutDetails.token;
  },
  [GUEST_FILL_OUT_CLIENT_DETAILS]: state => {
    const {
      clientDetails: {
        coApplicantId
      }
    } = state.guestFillOutDetails;
    return _objectSpread(_objectSpread({}, state.guestFillOutDetails.clientDetails), {}, {
      username: coApplicantId
    });
  },
  [CO_APPLICANTS_CONSOLIDATED_REQUEST_FILL_OUT]: state => {
    const {
      clientDetails: {
        coApplicantId
      }
    } = state.guestFillOutDetails;
    const {
      coApplicants
    } = state.consolidatedRequest.metadata || {};
    const applicantRequest = coApplicants == null ? void 0 : _findInstanceProperty(coApplicants).call(coApplicants, ({
      id
    }) => id === coApplicantId);
    return (applicantRequest == null ? void 0 : applicantRequest.fillOut) || [];
  },
  [GET_FILL_OUT_SECTIONS_SCHEMA_KEYS]: (state, getters) => {
    const fillOutSections = getters[CO_APPLICANTS_CONSOLIDATED_REQUEST_FILL_OUT];
    const {
      clientDetails: {
        clientUsername = ""
      }
    } = state.guestFillOutDetails;
    const schemaKeysMap = {
      [FILL_OUT_SECTIONS.PERSONAL_INFORMATION]: "co-applicants",
      [FILL_OUT_SECTIONS.MORTGAGE_DETAILS]: "mortgage-details",
      [FILL_OUT_SECTIONS.PROPERTY]: "property"
    };
    return _reduceInstanceProperty(fillOutSections).call(fillOutSections, (sections, {
      key,
      applicants
    }) => {
      if (applicants != null && _includesInstanceProperty(applicants).call(applicants, clientUsername)) sections.push("main-applicant");
      const section = schemaKeysMap[key];
      if (section) sections.push(section);
      return sections;
    }, []);
  },
  [FILL_OUT_HAS_COAPPLICANTS]: (state, getters) => {
    var _context;
    return _includesInstanceProperty(_context = getters[GET_FILL_OUT_SECTIONS_SCHEMA_KEYS]).call(_context, "co-applicants");
  },
  [FILL_OUT_APPLICATION_STATUS]: state => {
    const {
      coApplicantId
    } = state.guestFillOutDetails.clientDetails || {};
    const {
      coApplicants
    } = state.consolidatedRequest.metadata || {};
    const applicantRequest = coApplicants == null ? void 0 : _findInstanceProperty(coApplicants).call(coApplicants, ({
      id
    }) => id === coApplicantId);
    return (applicantRequest == null ? void 0 : applicantRequest.status) || "";
  }
};
export default getters;